export interface NovelData {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  cover: string;
  intro: string;
  tags: string[];
  status: string;
  wordCount: number;
  updatedAt: string;
  clicks: number;
  favorites: number;
  chapterTitles: string[];
}

export const novels: NovelData[] = [
  {
    id: "wan-gu-shen-di",
    title: "万古神帝诀",
    author: "云中鹤",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20chinese%20fantasy%20novel%20cover%2C%20lone%20cultivator%20in%20flowing%20dark%20robes%20standing%20atop%20a%20mountain%20peak%20with%20glowing%20golden%20energy%2C%20dramatic%20dawn%20light%2C%20painterly%20illustration%2C%20deep%20blue%20and%20amber%20tones%2C%20ornate%20atmospheric%20background&width=600&height=800&seq=novel-cover-01&orientation=portrait",
    intro:
      "大荒之上，万族林立，一个被夺去灵根的少年逆天改命，从最低处的矿奴一步步踏碎宗门律令。万古岁月沉浮，他终将以神帝之名，重铸九天秩序。",
    tags: ["热血", "升级流", "群像"],
    status: "连载",
    wordCount: 4280000,
    updatedAt: "2026-10-11",
    clicks: 9820000,
    favorites: 486000,
    chapterTitles: [
      "第一章 矿脉深处的少年",
      "第二章 被夺去的灵根",
      "第三章 破晓剑诀",
      "第四章 试炼场上的第一声",
      "第五章 长老的注视",
      "第六章 暗夜袭杀",
      "第七章 云雾城的买卖",
      "第八章 一缕残魂",
      "第九章 逆脉重开",
      "第十章 宗门大比",
      "第十一章 神帝烙印",
      "第十二章 万古之门",
    ],
  },
  {
    id: "chun-feng-bu-du-yu-men",
    title: "春风不度玉门",
    author: "沈砚之",
    category: "lishi",
    categoryName: "历史",
    cover:
      "https://readdy.ai/api/search-image?query=historical%20chinese%20novel%20cover%2C%20ancient%20frontier%20fortress%20at%20dusk%20with%20banners%20in%20the%20desert%20wind%2C%20a%20solitary%20general%20in%20armor%20gazing%20at%20distant%20mountains%2C%20muted%20crimson%20and%20sand%20tones%2C%20cinematic%20painterly%20style&width=600&height=800&seq=novel-cover-02&orientation=portrait",
    intro:
      "永昌三年，河西走廊烽烟四起。一个从书院走出的笔吏，被推上边关主帅之位。他将用兵书与胆魄，在大漠孤烟里写下属于自己的名字。",
    tags: ["权谋", "厚重", "家国"],
    status: "连载",
    wordCount: 2860000,
    updatedAt: "2026-10-10",
    clicks: 6240000,
    favorites: 312000,
    chapterTitles: [
      "第一章 长安来的调令",
      "第二章 河西的风",
      "第三章 孤城的粮草",
      "第四章 夜叩玉门",
      "第五章 沙盘推演",
      "第六章 叛将的名字",
      "第七章 一封家书",
      "第八章 雪落关山",
      "第九章 会战前夕",
      "第十章 烽火连天",
    ],
  },
  {
    id: "ta-yu-ta-xun-huan",
    title: "他予她欢喜",
    author: "温以宁",
    category: "yanqing",
    categoryName: "言情",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20novel%20cover%2C%20soft%20portrait%20of%20a%20young%20couple%20in%20a%20sunlit%20city%20park%20with%20cherry%20blossoms%2C%20warm%20pastel%20peach%20and%20cream%20tones%2C%20gentle%20bokeh%2C%20dreamy%20romantic%20illustration&width=600&height=800&seq=novel-cover-03&orientation=portrait",
    intro:
      "设计师林晚在最狼狈的雨天，撞进了投资人程予的怀里。从此城市霓虹之下，一场势均力敌又温柔妥帖的心动缓缓展开。",
    tags: ["甜宠", "双洁", "都市"],
    status: "完结",
    wordCount: 1240000,
    updatedAt: "2026-09-28",
    clicks: 4180000,
    favorites: 268000,
    chapterTitles: [
      "第一章 雨里的意外",
      "第二章 同一场发布会",
      "第三章 加班的深夜",
      "第四章 他记得的口味",
      "第五章 旧照片",
      "第六章 出差同城",
      "第七章 迟来的告白",
      "第八章 一起看的日落",
    ],
  },
  {
    id: "jian-lai-jiu-tian",
    title: "剑来九天",
    author: "顾清寒",
    category: "xianxia",
    categoryName: "仙侠",
    cover:
      "https://readdy.ai/api/search-image?query=xianxia%20cultivation%20novel%20cover%2C%20sword%20immortal%20in%20white%20robes%20standing%20on%20floating%20clouds%20above%20jade%20mountains%2C%20glowing%20azure%20sword%20light%2C%20ethereal%20mist%2C%20traditional%20chinese%20ink%20painting%20style%20with%20soft%20teal%20accents&width=600&height=800&seq=novel-cover-04&orientation=portrait",
    intro:
      "少年陈清源偶得一柄断剑，剑中藏着上古剑仙的一缕剑意。从青石小镇走向仙门之巅，他要问一句：何为长生，何为大道。",
    tags: ["剑修", "古典", "热血"],
    status: "连载",
    wordCount: 3520000,
    updatedAt: "2026-10-12",
    clicks: 7360000,
    favorites: 402000,
    chapterTitles: [
      "第一章 青石镇的断剑",
      "第二章 剑意的第一次苏醒",
      "第三章 拜入山门",
      "第四章 问剑台上",
      "第五章 云海试剑",
      "第六章 妖潮",
      "第七章 剑仙残念",
      "第八章 一气化三清",
      "第九章 九天之上",
      "第十章 剑来",
    ],
  },
  {
    id: "du-shi-jue-xing-zhe",
    title: "都市觉醒者",
    author: "墨白",
    category: "dushi",
    categoryName: "都市",
    cover:
      "https://readdy.ai/api/search-image?query=urban%20fantasy%20novel%20cover%2C%20young%20man%20in%20modern%20city%20street%20at%20night%20with%20glowing%20cyan%20energy%20lines%20around%20his%20hands%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20moody%20dark%20teal%20and%20orange%20lighting%2C%20cinematic%20illustration&width=600&height=800&seq=novel-cover-05&orientation=portrait",
    intro:
      "平凡的写字楼里，顾川在一次地铁事故后觉醒了罕见的念动力。平静的都市水面之下，一个由觉醒者组成的隐秘世界正徐徐展开。",
    tags: ["异能", "逆袭", "爽文"],
    status: "连载",
    wordCount: 2680000,
    updatedAt: "2026-10-11",
    clicks: 5520000,
    favorites: 224000,
    chapterTitles: [
      "第一章 地铁里的三秒",
      "第二章 会动的纸杯",
      "第三章 第一个同行者",
      "第四章 午夜的任务",
      "第五章 地下拍卖会",
      "第六章 念力的边界",
      "第七章 老楼里的秘密",
      "第八章 城市的另一面",
    ],
  },
  {
    id: "wu-ming-shan-zhuang",
    title: "无名山庄谜案",
    author: "唐墨言",
    category: "xuanyi",
    categoryName: "悬疑",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20thriller%20novel%20cover%2C%20foggy%20old%20mountain%20manor%20with%20a%20single%20lit%20window%20at%20night%2C%20bare%20twisted%20trees%2C%20deep%20indigo%20and%20dim%20amber%20tones%2C%20eerie%20atmospheric%20illustration%2C%20subtle%20rain&width=600&height=800&seq=novel-cover-06&orientation=portrait",
    intro:
      "大雪封山的第七夜，无名山庄里死了第二个人。受邀而来的推理作家发现，每个人都在说真话，也没有一个人说的全是真话。",
    tags: ["推理", "反转", "群像"],
    status: "完结",
    wordCount: 860000,
    updatedAt: "2026-09-20",
    clicks: 3420000,
    favorites: 198000,
    chapterTitles: [
      "第一章 第七个被邀请的人",
      "第二章 第一具尸体",
      "第三章 每个人都在说谎",
      "第四章 密室里的脚印",
      "第五章 过去的信",
      "第六章 第二声钟响",
      "第七章 真正的凶手",
      "第八章 雪停了",
    ],
  },
  {
    id: "xing-ji-yuan-zheng",
    title: "星际远征纪元",
    author: "陆行舟",
    category: "kehuan",
    categoryName: "科幻",
    cover:
      "https://readdy.ai/api/search-image?query=science%20fiction%20novel%20cover%2C%20massive%20starship%20floating%20near%20a%20ringed%20planet%2C%20distant%20blue%20nebula%20and%20stars%2C%20a%20lone%20astronaut%20silhouette%2C%20cool%20indigo%20and%20silver%20tones%20with%20warm%20engine%20glow%2C%20cinematic%20space%20illustration&width=600&height=800&seq=novel-cover-07&orientation=portrait",
    intro:
      "人类文明在银河边陲点亮第一座星门时，没人想到门后等待着的，是一场跨越三千年的远征，以及一个关于起源的惊人答案。",
    tags: ["太空歌剧", "群像", "硬核"],
    status: "连载",
    wordCount: 3120000,
    updatedAt: "2026-10-09",
    clicks: 4860000,
    favorites: 246000,
    chapterTitles: [
      "第一章 星门开启",
      "第二章 深空号启航",
      "第三章 休眠舱里的梦",
      "第四章 未知信号",
      "第五章 环带上的文明",
      "第六章 第一次接触",
      "第七章 远征的代价",
      "第八章 归途坐标",
    ],
  },
  {
    id: "hu-ju-dao",
    title: "虎踞刀",
    author: "燕十九",
    category: "wuxia",
    categoryName: "武侠",
    cover:
      "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20novel%20cover%2C%20lone%20swordsman%20with%20a%20broad%20blade%20standing%20in%20bamboo%20forest%20during%20light%20rain%2C%20green%20and%20ink%20black%20tones%2C%20dynamic%20brushstroke%20style%2C%20misty%20atmosphere&width=600&height=800&seq=novel-cover-08&orientation=portrait",
    intro:
      "刀客燕不归背着一柄与自己等身的虎踞刀，走过十七座城，只为赴一场迟到了十年的约。江湖路远，恩怨未了。",
    tags: ["快意恩仇", "江湖", "硬派"],
    status: "连载",
    wordCount: 1980000,
    updatedAt: "2026-10-08",
    clicks: 3980000,
    favorites: 176000,
    chapterTitles: [
      "第一章 雨夜刀客",
      "第二章 客栈里的赌局",
      "第三章 十七座城",
      "第四章 旧约",
      "第五章 竹林之战",
      "第六章 刀出如虎",
      "第七章 江湖规矩",
      "第八章 迟了十年",
    ],
  },
  {
    id: "mo-dao-qing-tian",
    title: "魔道擎天",
    author: "玄冥子",
    category: "xuanhuan",
    categoryName: "玄幻",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20fantasy%20chinese%20novel%20cover%2C%20demon%20cultivator%20with%20crimson%20glowing%20eyes%20amid%20black%20smoke%20and%20embers%2C%20deep%20violet%20black%20tones%20with%20red%20highlights%2C%20dramatic%20painterly%20illustration%2C%20ominous%20skies&width=600&height=800&seq=novel-cover-09&orientation=portrait",
    intro:
      "世人皆道正道煌煌，可正道之下的白骨又有谁记得。少年萧无咎自幽冥归来，他要做的，是把这虚伪的天，连根拔起。",
    tags: ["暗黑", "热血", "反套路"],
    status: "连载",
    wordCount: 3960000,
    updatedAt: "2026-10-12",
    clicks: 8120000,
    favorites: 421000,
    chapterTitles: [
      "第一章 自幽冥归来",
      "第二章 白骨路",
      "第三章 第一桩血债",
      "第四章 正道与魔道",
      "第五章 黑市里的帮手",
      "第六章 擎天一击",
      "第七章 虚伪的天",
      "第八章 连根拔起",
    ],
  },
  {
    id: "ling-long-fu",
    title: "玲珑赋",
    author: "青玉案",
    category: "yanqing",
    categoryName: "言情",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20romance%20novel%20cover%2C%20elegant%20lady%20in%20embroidered%20hanfu%20holding%20a%20jade%20bracelet%20in%20a%20lantern-lit%20courtyard%2C%20warm%20gold%20and%20rose%20tones%2C%20guzhuang%20classical%20illustration%2C%20delicate%20ornamental%20details&width=600&height=800&seq=novel-cover-10&orientation=portrait",
    intro:
      "她本是深闺中被藏起的一块璞玉，一纸赐婚却把她推入了诡谲的宫廷。她以才情为刃，以温柔为守，为自己挣得一方天地。",
    tags: ["古言", "强强", "权谋"],
    status: "连载",
    wordCount: 1620000,
    updatedAt: "2026-10-07",
    clicks: 3640000,
    favorites: 187000,
    chapterTitles: [
      "第一章 一纸赐婚",
      "第二章 深闺璞玉",
      "第三章 初见东宫",
      "第四章 灯会上的棋局",
      "第五章 宫墙里的风",
      "第六章 以才为刃",
      "第七章 月下盟约",
      "第八章 一方天地",
    ],
  },
  {
    id: "chong-sheng-zhi-hou",
    title: "重生之后我只想种田",
    author: "小满",
    category: "dushi",
    categoryName: "都市",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20slice%20of%20life%20novel%20cover%2C%20sunlit%20small%20farming%20homestead%20with%20vegetable%20garden%20and%20wooden%20fence%2C%20warm%20amber%20and%20green%20tones%2C%20gentle%20rural%20illustration%2C%20inviting%20peaceful%20atmosphere&width=600&height=800&seq=novel-cover-11&orientation=portrait",
    intro:
      "一觉醒来，林知夏回到了十八岁那年的春天。上一世她拼尽全力却满身伤，这一世她决定守着老家的一亩三分地，慢慢把日子过成诗。",
    tags: ["种田", "治愈", "轻松"],
    status: "完结",
    wordCount: 1120000,
    updatedAt: "2026-09-30",
    clicks: 2860000,
    favorites: 164000,
    chapterTitles: [
      "第一章 回到十八岁的春天",
      "第二章 菜园的第一株苗",
      "第三章 小镇的集市",
      "第四章 旧同学来访",
      "第五章 慢慢做成的事",
      "第六章 一个决定",
      "第七章 把日子过成诗",
      "第八章 春天还会来",
    ],
  },
  {
    id: "xuan-he-ling",
    title: "玄河令",
    author: "白鹿鸣",
    category: "wuxia",
    categoryName: "武侠",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20jianghu%20wuxia%20novel%20cover%2C%20snowy%20riverbank%20with%20a%20mysterious%20jade%20tally%20and%20an%20ancient%20bridge%2C%20cool%20steel%20blue%20and%20frost%20white%20tones%2C%20elegant%20ink%20painting%20illustration%2C%20quiet%20dramatic%20mood&width=600&height=800&seq=novel-cover-12&orientation=portrait",
    intro:
      "玄河令一出，江湖无宁日。这枚传说中的令牌牵动着九大门派的命脉，也让一个无名少年被卷入了本不属于他的风波。",
    tags: ["江湖", "群像", "悬念"],
    status: "连载",
    wordCount: 2240000,
    updatedAt: "2026-10-06",
    clicks: 4260000,
    favorites: 203000,
    chapterTitles: [
      "第一章 玄河令现世",
      "第二章 无名的少年",
      "第三章 九大门派",
      "第四章 雪夜渡船",
      "第五章 古桥之约",
      "第六章 令牌的秘密",
      "第七章 剑试群雄",
      "第八章 江湖无宁日",
    ],
  },
];